// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1BL2D","question":"styles_question__2ONNg","description":"styles_description__X25vN"};